export const isFloat = (value, options = { allowNegative: false }) => {
    const regex = options.allowNegative ? /^-?\d+(?:[,.]?\d*)?$/ : /^\d+(?:[,.]?\d*)?$/;

    return regex.test(value);
};
